import moment from 'moment';

const getReportAttendanceHostResponse = (response) => {
  const result = {
    isDataExist: response?.data?.isDataExist || false,
    totalCount: response?.data?.totalData || 0,
    currentPage: response?.data?.currentPage || 0,
    totalPage: response?.data?.totalPage || 0,
    reports:
      response?.data?.data?.map((item) => ({
        hostName: item?.hostName || '-',
        hostId: item?.hostId || 0,
        brandName: item?.brandName || '-',
        startedAt: item?.startedAt || '-',
        endedAt: item?.endedAt || '-',
        reportPeriod: `${moment(item?.startedAt).format('DD MMM YYYY')} - ${moment(item?.endedAt).format('DD MMM YYYY')}`,
        totalWorkingDays: item?.totalWorkingDays || 0,
        totalLateClockIn: item?.totalLateClockIn || 0,
        totalStreamingSessions: item?.totalStreamingSessions || 0,
        totalLateStreamingSessions: item?.totalLateStreamingSessions || 0,
        totalWorkingHours: item?.totalWorkingHours || '0',
        totalLivestreamHours: item?.totalLivestreamHours || '0',
        totalTasks: item?.totalTasks || 0,
      })) || [],
  };

  return result;
};

export default getReportAttendanceHostResponse;
